import React, { useState } from 'react'
import { connect } from 'react-redux'
import UpcomingAppointmentsCard from '../../../components/upcomingAppointmentsCard'
import { Section, SectionTitle, SectionHeader } from '../../../styled/sections'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import Feedback from '../../../components/feedback'
import { useUpcomingAppointments } from '../../../hooks/useUpcomingAppointments'

const UpcomingAppointments = (props) => {
	const [showFeedback, setShowFeedback] = useState({ show: false, success: false })
	const history = useHistory()
	const { todayAppointments, allUpcomingAppointments } = useUpcomingAppointments({
		patientId: props.patient?.idPaciente,
		dispatch: props.dispatch,
		limit: Number.MAX_SAFE_INTEGER
	})

	return (
		<div style={{ width: '100%' }}>
			{showFeedback.show ?
				<Feedback
					title={showFeedback.success ? 'Tu turno fue cancelado con éxito' : 'Error al cancelar el turno'}
					bodyText={showFeedback.success ? undefined : 'Hubo un error al cancelar el turno. Por favor, inténtelo de nuevo.'}
					buttonLabel={'Volver al inicio'}
					onClickButton={() => history.push('/inicio')}
					isSuccess={showFeedback.success}
					isError={!showFeedback.success}
				/>
				: (
					<>
						<Section>
							<SectionHeader align="left">
								<SectionTitle>Turnos para hoy</SectionTitle>
							</SectionHeader>
							<UpcomingAppointmentsCard appointments={todayAppointments} setShowFeedback={setShowFeedback} />
						</Section>
						<Section>
							<SectionHeader align="left">
								<SectionTitle>Próximos turnos</SectionTitle>
							</SectionHeader>
							<UpcomingAppointmentsCard appointments={allUpcomingAppointments} setShowFeedback={setShowFeedback}/>
						</Section>
					</>
				)}
		</div>
	)
}

const mapStateToProps = ({ patient }) => ({ patient })

export default connect(mapStateToProps)(UpcomingAppointments)